<div style="border-left: 5px solid rgb(207, 121, 1);border-right: 5px solid rgb(207, 121, 1);  font-size: 12px;">
    <div class="backgroundTela">
        &nbsp;
    </div>
    <mat-tab-group [selectedIndex]="selectedIndex" animationDuration="100ms" style=" margin-left: 5px;">
        
        
        <mat-tab *ngFor="let number of [0];let i=index;" label="📝Plano de ação">

            <form [formGroup]="formularioPlanoDeAcao" novalidate>

                <!--Definir o tamanho da tela-->
                <div style=" width: 100%; overflow:hidden; text-align: center;">

                <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">

                        <table style="width: 98%; ">

                        <tr>

                            <td style="width: 25%;">&nbsp;</td>

                            <td style="width: 50%;" >

                                <mat-card style="padding: 0px; width: 98%;  height: 47px; margin: auto; margin-top: 5px;">
                                    <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                                        <mat-label style="text-align: left;">
                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                        <b> Operação</b>
                                        <i>(Empresa)</i>
                                        </mat-label>
                                        <mat-select formControlName="idOperacaoMenu"  (selectionChange)="limparListas();buscarPlanosDeAcoes() "
                                                    style="text-align: center; font-size: 12px; font-weight: 500;">
                                                <mat-option *ngFor="let colunas of lstCmbOperacao"
                                                            [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                                                </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    </mat-card>


                            </td>

                            <td style="width: 25%;">&nbsp;</td>


                        </tr>

                        </table>

                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                </div>


                <div style="margin-top: 15px;">
                <!--container ajustado dinamicamente-->
                <div id="divContainer">

                    <div id="divAdjustAutoHeight">

                    <div style="margin-left: 5px; margin-right: 5px;">

                    <!--DIV ESQUERDA-->
                    <div id="formAndListLeft"  *ngIf="formularioPlanoDeAcao.controls.idOperacaoMenu.value != ''">

                        <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div style=" margin-left: 15px; font-size: 14px; " *ngIf="formularioPlanoDeAcao.controls.placIdCdPlanoacao.value == ''; else editarUsuario">Novo cadastro</div>
                        <ng-template #editarUsuario>
                            <div style=" margin-left: 15px; font-size: 14px; ">Editar cadastro</div>
                        </ng-template>
                        </div>
                        <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                        <mat-card class="mat-elevation-z8" style="padding: 8px;">

<!--
                            <div style="position: relative; font-weight: 500; color: white; z-index: 1; margin-top: 15px;">
                                &nbsp;&nbsp;{{statusPlanoAcaoFormulario}}
                            </div>
                            <div style="position: relative; margin-top: -20px;  z-index: 0;">
                                <mat-progress-bar 
                                mode="determinate" style="height: 25px;"
                                [color]="statusPlanoAcaoFormulario == 'ENCERRADO' ? 'primary' :  statusPlanoAcaoFormulario >= 'ONLINE' ? 'warn' :'accent'" 
                                [value]="statusPlanoAcaoFormulario == 'ENCERRADO' ? '100' : percentualFormulario"></mat-progress-bar>
                            </div>
                            <br/>-->
                            <!--container ajustado dinamicamente-->
                            <div id="subDivContainer" style="width: 100%; ">
                                <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                                <input hidden matInput formControlName="placIdCdPlanoacao">

                                <table style="width: 100%;">
                                    
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                            <mat-form-field appearance="outline" >
                                                <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Ação</b>
                                                <i>(Obrigatório)</i>
                                                </mat-label>
                                                <input matInput formControlName="placDsAcao" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                        <mat-form-field appearance="outline" >
                                            <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Objetivo</b>
                                            <i>(Obrigatório)</i>
                                            </mat-label>
                                            <textarea matInput placeholder="Descrição" rows="4" style="white-space: pre-line;" formControlName="placdsobjetivo"
                                                         onchange="this.value = this.value.toUpperCase()">
                                            </textarea>
                                        </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%; text-align: right; " colspan="2">
                                           

                                            <span *ngIf="qtdAnexos > 0"
                                                style="color:#3b3c3d; margin-right: 1rem; cursor: pointer; margin-right: 27px;
                                                        position: relative; top: 15px; z-index: 1000;"
                                                matTooltip="Quantidade de agendamentos atrasados."
                                                matTooltipPosition="left"
                                                matBadge = {{qtdAnexos}}
                                                matBadgeOverlap="false"
                                                matBadgeColor="warn">
                                                    &nbsp;
                                            </span>
                                                
                                            <br/>

                                            <!-- ADICIONANDO UPLOAD DE ARQUIVO NA TELA DE LISTA ANEXOS - DANILLO 17/07/2023 -->
                                            <button mat-raised-button  *ngIf="formularioPlanoDeAcao.controls.placIdCdPlanoacao.value != ''"
                                                style="outline: none; background-color: rgb(46, 163, 80); color:white; width: 110px; height: 25px; cursor: pointer; margin-right: 5px;"
                                                (click)="loadDialogAnexo()">
                                                
                                            <label style="outline: none; cursor: pointer; ">
                                                <mat-icon style="width: 18px;">attach_file</mat-icon>
                                            </label>
                                            &nbsp;
                                            <label style="outline: none; cursor: pointer; margin-top: -10px;">
                                                Anexos
                                            </label>
                                            &nbsp;
                                        </button>
                                        
                                            <!--
                                            <input type="file" class="file-input" id="anexoMonitoria"
                                            [accept]="requiredFileType"
                                            (change)="instanciarArquivo($event, fileUpload)" #fileUpload style="display: none;">
                                
                                            <div class="file-upload" style="vertical-align: bottom; margin-right: 15px;">
                                                <button *ngIf="!contemAnexo"  mat-mini-fab style="background-color: rgb(207, 121, 1); width: 40px; height: 40px; " class="upload-btn"
                                                    (click)="fileUpload.click()">
                                                    <mat-icon style="width: 25px;"> attach_file</mat-icon>
                                                </button>

                                                <button *ngIf="contemAnexo"  mat-mini-fab style="background-color: rgb(207, 121, 1);" class="upload-btn"
                                                    (click)="downloadAnexo()">
                                                    <mat-icon>cloud_download</mat-icon>
                                                </button>
                                            &nbsp;
                                                {{fileName || "Sem arquivo anexo"}}
                                    
                                                <mat-icon  *ngIf="contemAnexo" style="color: rgb(248, 41, 110);  vertical-align: middle; cursor: pointer; font-weight: bold;"
                                                    (click)="deletarAnexo()">
                                                    close
                                                </mat-icon>                            
                                            </div>
                                            -->


                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                           
                                           
                                            <div style="display: flex;">
                                                <mat-form-field appearance="outline"  style="margin-right: 5px;">
                                                    <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Data de Inicio da Ação</b>
                                                    <i>*</i>
                                                    </mat-label>
                                                    <input matInput [matDatepicker]="picker" readonly formControlName="placDhDataacao">
                                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                
                                              </div>
                                           
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">

                                            <div style="display: flex;">

                                                <mat-form-field appearance="outline" style="margin-right: 5px;" >
                                                    <mat-label>
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Duração em dias</b>
                                                    <i>*</i>
                                                    </mat-label>
                                                    <input matInput type="number" formControlName="placNrPrazodiasacao" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </tr>
                                    

                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                        <mat-form-field appearance="outline" >
                                            <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Responsável</b>
                                            <i>(Obrigatório)</i>
                                            </mat-label>
                                            <input matInput formControlName="placDsResponsavel" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                        </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                            <mat-form-field appearance="outline" >
                                            <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Status do plano de ação</b>
                                                <i>(Obrigatório)</i>
                                            </mat-label>
                                            <mat-select formControlName="stacIdCdStatusacao" >
                                                <mat-option *ngFor="let colunas of lstCmbStatusPlanoAcao"
                                                            [value]="colunas.stacIdCdStatusacao">{{colunas.stacDsStatusacao}}
                                                </mat-option>
                                            </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                        <mat-form-field appearance="outline" >
                                            <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Análise de eficácia</b>
                                            </mat-label>
                                            <input matInput formControlName="placDsAnaliseeficacia" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                        </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>

                                        <td style="width: 100%;" colspan="2">
                                            <mat-form-field appearance="outline" >
                                                <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Resultado Obtido</b>
                                                <i>(Obrigatório)</i>
                                                </mat-label>
                                                <input matInput formControlName="placDsTracker" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                        <mat-form-field appearance="outline" >
                                            <mat-label>
                                            <img src="../../assets/img/icones/chat.png" width="20px">&nbsp;&nbsp;
                                            <b> Observações</b>
                                            </mat-label>
                                            <textarea matInput placeholder="Observações" rows="4" style="white-space: pre-line;" formControlName="placDsObservacao"
                                                         onchange="this.value = this.value.toUpperCase()" maxlength="800">
                                            </textarea>
                                        </mat-form-field>
                                        </td>
                                    </tr>
                                   

                                    <tr>
    
                                        <td style="width: 74%; text-align: left;">
                                            <div style="width:100%; margin-top: 18px;">
                                                
                                               <!-- <mat-slide-toggle style="font-size: 12px; " formControlName="isInativo" >Cadastro inativo?</mat-slide-toggle>-->
                                               <label *ngIf="formularioPlanoDeAcao.controls.nmUserupdate.value != '' && formularioPlanoDeAcao.controls.nmUserupdate.value != undefined ">
                                                    Atualizado por : {{formularioPlanoDeAcao.controls.nmUserupdate?.value.substring(0,20)+ '...'}} em {{formularioPlanoDeAcao.controls.dhUpdate.value  | date: 'dd/MM/yyyy HH:mm:ss' }} 
                                                </label>
                                            </div>
                                        </td>
                                        <td style="width: 24%; text-align: center;">
                                            <div style="width:100%; margin-top: 18px; font-weight: 500;">
                                                
                                                <label *ngIf="formularioPlanoDeAcao.controls.placDhCadastro.value != ''">
                                                    Data Cadastro : {{formularioPlanoDeAcao.controls.placDhCadastro.value | date: 'dd/MM/yyyy'}}
                                                </label>
                                               
                                            </div>
                                        </td>

                                    </tr>
                                    <tr >
    
                                        <td style="width: 100%; text-align: center; height: 10px;" colspan="2">&nbsp;
                                           
                                        </td>

                                    </tr>
                                    
                                </table>
                                
                            </div>

                            <div style="width: 100%; margin-top: 05px;">

                                <div style="float: left; width: 69%; ">
                                    <button mat-raised-button  type="button" (click)="add()"
                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%; margin-top: 20px; font-size: 12px">
                                    Salvar
                                    </button>
                                </div>

                                <div style="float: left; width: 30%; ">
                                    <button mat-raised-button type="button" (click)="clearFormulario()" color="warn" style="color: #fff; width: 99%; margin-top: 20px; font-size: 12px ">
                                    Cancelar
                                    </button>
                                </div>

                            </div>

                            </div>
                        </mat-card>
                        <br/>
                    </div>



                    <!--DIV DIREITA-->
                    <!--container ajustado dinamicamente-->
                    <div id="formAndListRight" style="margin-left: 10px; "  *ngIf="formularioPlanoDeAcao.controls.idOperacaoMenu.value != ''">


                    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div style=" margin-left: 15px; font-size: 14px;">Lista de Plano de Ação</div>
                    </div>
                    <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                        <mat-card class="mat-elevation-z8" style="padding: 8px;">

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                </mat-form-field>
                            </div>

                            <!--container ajustado dinamicamente-->
                            <div id="subDivContainer" style="width: 100%; ">
                                <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">


                                <table mat-table [dataSource]="dataSource" matSort #sortUsuario="matSort" matSortActive="statusPlanoAcao" matSortDirection="asc" 
                                    class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                    <ng-container matColumnDef="placIdCdPlanoacao" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:5%;"> ID </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormPlanoDeAcao(element)" matTooltip="{{element.placIdCdPlanoacao}}" style="width:5%; cursor: pointer;"> 
                                            {{element.placIdCdPlanoacao}}
                                        </td>
                                    </ng-container>

                                    <!-- Symbol Column -->
                                    <ng-container matColumnDef="placDsAcao" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:25%;"> Plano de Ação </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormPlanoDeAcao(element)" matTooltip="{{element.placdsobjetivo}}" style="width:25%; cursor: pointer;"> 
                                            {{element.placDsAcao}}
                                        </td>
                                    </ng-container>


                                    <!-- Symbol Column -->
                                     <!--
                                    <ng-container matColumnDef="anexo" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:5%;"> Anexo </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormPlanoDeAcao(element)" matTooltip="Anexar Arquivo" style="width:5%; cursor: pointer;"> 
                                            &nbsp;&nbsp;<mat-icon *ngIf="element.actionPlanFiles != null" >attach_file</mat-icon> 
                                            {{element.actionPlanFiles | json }}
                                        </td>
                                    </ng-container>
                                    -->
                                    <!-- Name Column -->
                                    <!--<ng-container matColumnDef="placDhCadastro">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%;"> Cadastro </th>
                                            <td mat-cell *matCellDef="let element"  (click)="setFormPlanoDeAcao(element)" matTooltip="{{element.placdsobjetivo}}" style="width:15%; cursor: pointer;"> 
                                                {{element.placDhCadastro | date: 'dd/MM/yyyy'}}  
                                            </td>
                                        </ng-container>-->

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="placDhDataacao">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:10%;"> Inicio </th>
                                        <td mat-cell *matCellDef="let element"  (click)="setFormPlanoDeAcao(element)" matTooltip="{{element.placdsobjetivo}}" style="width:10%; cursor: pointer;"> 
                                            {{element.placDhDataacao | date: 'dd/MM/yyyy'}}  
                                        </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="datafinalacao">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:10%;"> Fim </th>
                                        <td mat-cell *matCellDef="let element"  (click)="setFormPlanoDeAcao(element)" matTooltip="{{element.placdsobjetivo}}" style="width:10%; cursor: pointer;"> 
                                            {{element.datafinalacao | date: 'dd/MM/yyyy'}}  </td>
                                    </ng-container>


                                    <!-- Symbol Column -->
                                    <ng-container matColumnDef="statusPlanoAcao" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Progresso/Status </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormPlanoDeAcao(element)" style="width:25%; cursor: pointer;"> 
                                          

                                            <div style="position: relative; font-weight: 500; color: white; z-index: 1; font-size: 14px;" matTooltip="{{element.placdsobjetivo}}">
                                                   <!--&nbsp;&nbsp;{{element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) == 'ONLINE' ? element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) +' '+element.percentual+'%' : element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) }}-->
                                                &nbsp; {{element.statusObj.stacDsStatusacao}} {{element.placDhConcluido | date: 'dd/MM/yyyy'}}
                                            </div>
   
                                            <div style="position: relative; margin-top: -22px;  z-index: 0;">
                                                <mat-progress-bar [class]="element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) == 'ENCERRADO' ? ((element.placDhConcluido | date: 'yyyyMMdd') | number) > ((element.datafinalacao | date: 'yyyyMMdd') | number) ? 'red' : element.placDhConcluido == null ? 'red': 'blue'
                                                                                    :  element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) >= 'ONLINE' ? 'green' 
                                                                                        :'yellow'"
                                                
                                                mode="determinate" style="height: 25px;"
                                                [value]="element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) == 'ENCERRADO' ? '100' : element.statusPlanoAcao.substring(3,element.statusPlanoAcao.length) == 'AGUARDANDO' ? '100' : element.percentual"></mat-progress-bar>
                                            </div>
                                        </td>
                                    </ng-container>


                                    <ng-container matColumnDef="excluir" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:5%;">Excluir</th>
                                        <td mat-cell *matCellDef="let element" (click)="excluirPlanoAcao(element)" matTooltip="Excluir" style="width:10%; cursor: pointer;"> 
                                            &nbsp;&nbsp;
                                             <mat-icon>highlight_off</mat-icon>
                                        
                                        </td>
                                    </ng-container>


                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 20px;"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns; " class="aoPassarMouse" style="height: 50px;"></tr>
                                    </table>

                                </div>
                            </div>
                        </mat-card>

                    </div>






                    </div>

                    </div>

                </div>

                </div>
            </form>

        </mat-tab>



        <mat-tab *ngFor="let number of [1];let i=index;" label="📝Parecer">

            <form [formGroup]="formularioParecer" novalidate>

                <!--Definir o tamanho da tela-->
                <div style=" width: 100%; overflow:hidden; text-align: center;">

                <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">

                        <table style="width: 98%; ">

                        <tr>

                            <td style="width: 100%;">&nbsp;</td>

                        </tr>

                        </table>

                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                </div>


                <div style="margin-top: 15px;">
                <!--container ajustado dinamicamente-->
                <div id="divContainer">

                    <div id="divAdjustAutoHeight">

                    <div style="margin-left: 5px; margin-right: 5px;">

                    <!--DIV ESQUERDA-->
                    <div id="formAndListLeft">

                        <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div style=" margin-left: 15px; font-size: 14px; " *ngIf="formularioParecer.controls.pareIdCdParecer.value == ''; else editarUsuario">Novo cadastro</div>
                        <ng-template #editarUsuario>
                            <div style=" margin-left: 15px; font-size: 14px; ">Editar cadastro</div>
                        </ng-template>
                        </div>
                        <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                        <mat-card class="mat-elevation-z8" style="padding: 8px;">

                            <!--container ajustado dinamicamente-->
                            <div id="subDivContainer" style="width: 100%; ">
                                <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                                <input hidden matInput formControlName="pareIdCdParecer">

                                <table style="width: 100%;">
                                    
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                            <mat-form-field appearance="outline" >
                                                <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Operação</b>
                                                    <i>(Empresa)</i>
                                                </mat-label>
                                                <mat-select formControlName="idOperacaoMenu"  (selectionChange)="limparListas(); "
                                                            style="text-align: left; font-size: 12px; font-weight: 500;">
                                                <mat-option *ngFor="let colunas of lstCmbOperacao"
                                                            [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                                                </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 75%;"  colspan="2">
                                            <mat-form-field appearance="outline" >
                                                <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Mes</b>
                                                    <i>(Do Ano)</i>
                                                </mat-label>
                                                <mat-select formControlName="meseIdCdMeses"  (selectionChange)="limparListas(); "
                                                            style="text-align: left; font-size: 12px; font-weight: 500;">
                                                <mat-option *ngFor="let colunas of lstCmbMesParecer"
                                                            [value]="colunas.meseIdCdMeses">{{colunas.meseDsMes}}
                                                </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                            <mat-form-field appearance="outline" >
                                                <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Ano</b>
                                                <i>(Ano do Parecer)</i>
                                                </mat-label>
                                                <input matInput type="number" formControlName="pareNrAno" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                        </td> 
                                    </tr>
                                    <tr>
                                        <td style="width: 100%;" colspan="2">
                                        <mat-form-field appearance="outline" >
                                            <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Parecer</b>
                                            <i>(Obrigatório)</i>
                                            </mat-label>
                                            <textarea matInput placeholder="Descrição" rows="30" style="white-space: pre-line;" formControlName="pareTxParecer"
                                                         onchange="this.value = this.value.toUpperCase()">
                                            </textarea>
                                        </mat-form-field>
                                        
                                        </td>
                                    </tr>

                                    <tr>
    
                                        <td style="width: 75%; text-align: left;">
                                            <div style="width:100%; margin-top: 18px;">
                                                
                                                <mat-slide-toggle style="font-size: 12px; " formControlName="isInativo" >Cadastro inativo?</mat-slide-toggle>
                                                
                                                  
                                            </div>
                                        </td>
                                        <td style="width: 25%; text-align: center;">
                                            <div style="width:100%; margin-top: 18px; font-weight: 500;">
                                                
                                                <label *ngIf="formularioParecer.controls.pareDhCadastro.value != ''">
                                                    Data Cadastro : {{formularioParecer.controls.pareDhCadastro.value | date: 'dd/MM/yyyy'}}
                                                </label>
                                            
                                               
                                            </div>
                                        </td>

                                    </tr>

                                    <tr >
    
                                        <td style="width: 100%; text-align: center; height: 10px;" colspan="2">
                                            &nbsp;
                                            
                                        </td>

                                    </tr>
                                    
                                </table>
                                
                            </div>

                            <div style="width: 100%; margin-top: 05px;">

                                <div style="float: left; width: 69%; ">
                                    <button mat-raised-button  type="button" (click)="addParecer()"
                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%; margin-top: 20px; font-size: 12px">
                                    Salvar
                                    </button>
                                </div>

                                <div style="float: left; width: 30%; ">
                                    <button mat-raised-button type="button" (click)="clearFormularioParecer()" color="warn" style="color: #fff; width: 99%; margin-top: 20px; font-size: 12px ">
                                    Cancelar
                                    </button>
                                </div>

                                </div>

                            </div>
                        </mat-card>
                        <br/>
                    </div>



                    <!--DIV DIREITA-->
                    <!--container ajustado dinamicamente-->
                    <div id="formAndListRight" style="margin-left: 10px;">


                    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div style=" margin-left: 15px; font-size: 14px;">Lista de Parecer</div>
                    </div>
                    <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                        <mat-card class="mat-elevation-z8" style="padding: 8px;">

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilterParecer($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                </mat-form-field>
                            </div>

                            <!--container ajustado dinamicamente-->
                            <div id="subDivContainer" style="width: 100%; ">
                                <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">

                               
                                <table mat-table [dataSource]="dataSourceParecer" matSort #sortParecer="matSort" 
                                    class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">
                                    
                                    <!-- Symbol Column -->
                                    <ng-container matColumnDef="operations" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:45%;"> Operação </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormParecer(element)" matTooltip="{{element.operNmOperacao}}" style="width:45%; cursor: pointer;"> 
                                            {{element.operations.operNmOperacao}}
                                        </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="month">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%;"> Mes</th>
                                        <td mat-cell *matCellDef="let element"  (click)="setFormParecer(element)" matTooltip="{{element.meseDsMes}}" style="width:15%; cursor: pointer;"> 
                                            {{element.month.meseDsMes}}  
                                        </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="pareNrAno">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%;"> Ano </th>
                                        <td mat-cell *matCellDef="let element"  (click)="setFormParecer(element)" matTooltip="{{element.pareNrAno}}" style="width:15%; cursor: pointer;"> 
                                            {{element.pareNrAno}}  </td>
                                    </ng-container>


                                    <!-- Symbol Column -->
                                    <ng-container matColumnDef="pareDhInativo" >
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:25%;"> Inativo? </th>
                                        <td mat-cell *matCellDef="let element" (click)="setFormParecer(element)" style="width:25%; cursor: pointer;"> 
                                          
                                            {{element.pareDhInativo | date: 'dd/MM/yyyy'}}  
                                        </td>
                                    </ng-container>


                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsParecer; sticky: true" style="height: 20px;"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsParecer; " class="aoPassarMouse" style="height: 50px;"></tr>
                                    </table>

                                </div>
                            </div>
                        </mat-card>

                    </div>






                    </div>

                    </div>

                </div>

                </div>
            </form>


        </mat-tab>

        
    </mat-tab-group>
</div>